var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordmarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "186.33281mm",
    height: "34.361382mm",
    viewBox: "0 0 186.33281 34.361382",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g857"
  }, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 6.359375,-12.40625 c 1.640625,0 1.953125,1.125 1.953125,3.140625 0,1.953125 -0.3125,3.15625 -1.953125,3.15625 -0.1875,0 -0.4375,0 -0.5625,-0.0625 v -6.171875 c 0.1875,-0.0625 0.375,-0.0625 0.5625,-0.0625 z m 9.578125,2.265625 H 13.421875 V -12.28125 H 16.375 v -1.578125 H 11.59375 V -4.71875 H 16.375 V -6.234375 H 13.421875 V -8.625 H 15.9375 Z M 6.234375,-4.59375 c 2.84375,0 3.90625,-1.453125 3.90625,-4.671875 0,-3.140625 -1,-4.71875 -3.84375,-4.71875 -0.625,0 -1.515625,0.125 -2.328125,0.25 v 9.015625 c 0.8125,0.125 1.765625,0.125 2.265625,0.125 z m 11.78125,-9.265625 c -0.1875,2.203125 -0.375,6.171875 -0.4375,9.140625 h 1.765625 c 0,-2.140625 0.0625,-4.421875 0.125,-6.5625 h 0.0625 l 1.265625,5.171875 h 1.6875 L 23.75,-11.28125 c 0.125,2.140625 0.1875,4.421875 0.1875,6.5625 h 1.828125 c -0.125,-2.96875 -0.25,-6.9375 -0.375,-9.140625 H 22.875 L 21.671875,-8.8125 20.46875,-13.859375 Z m 12.34375,9.265625 c 2.53125,0 3.40625,-1.453125 3.40625,-4.671875 0,-3.203125 -0.875,-4.71875 -3.40625,-4.71875 -2.515625,0 -3.328125,1.515625 -3.328125,4.71875 0,3.21875 0.8125,4.671875 3.328125,4.671875 z m 0,-7.8125 c 1.328125,0 1.578125,1.0625 1.578125,3.140625 0,2.015625 -0.25,3.15625 -1.578125,3.15625 -1.25,0 -1.5,-1.140625 -1.5,-3.15625 0,-2.078125 0.25,-3.140625 1.5,-3.140625 z M 29.734375,-31.25 C 24.5,-31.25 19.90625,-19.46875 19.90625,-19.46875 22.546875,-22.046875 25.828125,-23.5 30.359375,-24 c 1.328125,-0.1875 3.28125,-1.328125 3.28125,-3.28125 0,-1.328125 -0.625,-3.96875 -3.90625,-3.96875 z M 8.75,-27.96875 c -2.578125,0 -3.90625,1.953125 -3.90625,3.96875 0,1.953125 1.953125,3.265625 3.90625,3.265625 3.96875,0 7.25,1.265625 9.828125,4.546875 0,0 -3.90625,-11.78125 -9.828125,-11.78125 z m 11.03125,-9.390625 c -1.890625,-1.828125 -4.21875,-1.328125 -5.609375,0.0625 -1.3125,1.453125 -0.8125,3.71875 0.5625,5.109375 2.84375,2.703125 4.296875,5.984375 3.84375,10.140625 0,0 5.421875,-11.21875 1.203125,-15.3125 z m 0,0",
    id: "path833"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 3.15625,-21.921875 c 0,12.71875 9.890625,22.546875 22.859375,22.546875 8.890625,0 13.671875,-3.96875 15.375,-5.609375 0.75,-0.6875 1.328125,-1.6875 1.328125,-2.828125 0,-1.890625 -1.390625,-3.28125 -3.34375,-3.28125 -1.015625,0 -1.890625,0.515625 -2.578125,1.078125 C 35.03125,-8.4375 32,-6.046875 26.140625,-6.046875 c -8.9375,0 -15.75,-6.9375 -15.75,-16 0,-9.078125 6.8125,-16 15.75,-16 5.734375,0 8.890625,2.453125 10.265625,3.515625 0.703125,0.515625 1.515625,0.890625 2.46875,0.890625 1.828125,0 3.328125,-1.390625 3.328125,-3.34375 0,-1.3125 -0.6875,-2.453125 -1.953125,-3.328125 -2.015625,-1.515625 -6.546875,-4.421875 -13.984375,-4.421875 -12.96875,0 -23.109375,10.078125 -23.109375,22.8125 z m 0,0",
    id: "path836"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.671875,-3.65625 C 5.671875,-1.515625 7.1875,0 9.328125,0 H 35.03125 c 1.828125,0 3.078125,-1.328125 3.078125,-3.21875 0,-1.828125 -1.25,-3.078125 -3.078125,-3.078125 H 12.921875 V -19.90625 H 31.375 c 1.765625,0 2.953125,-1.203125 2.953125,-2.96875 0,-1.765625 -1.1875,-2.953125 -2.953125,-2.953125 H 12.921875 v -11.96875 h 21.46875 c 1.828125,0 3.09375,-1.328125 3.09375,-3.21875 0,-1.828125 -1.265625,-3.078125 -3.09375,-3.078125 h -25.0625 c -2.140625,0 -3.65625,1.5 -3.65625,3.578125 z m 0,0",
    id: "path839"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 5.671875,-3.28125 c 0,2.140625 1.453125,3.59375 3.59375,3.59375 2.078125,0 3.515625,-1.453125 3.515625,-3.59375 v -30.109375 l 22.8125,31.25 C 36.609375,-0.6875 38.046875,0.3125 39.75,0.3125 c 2.515625,0 4.34375,-1.890625 4.34375,-4.46875 v -36.796875 c 0,-2.015625 -1.4375,-3.46875 -3.515625,-3.46875 -2.078125,0 -3.53125,1.453125 -3.53125,3.46875 v 29.546875 l -22.4375,-30.609375 c -1,-1.515625 -2.515625,-2.40625 -4.15625,-2.40625 -2.765625,0 -4.78125,1.953125 -4.78125,4.796875 z m 0,0",
    id: "path842"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 32.953125,-44.09375 H 3.96875 c -1.890625,0 -3.15625,1.25 -3.15625,3.078125 0,1.890625 1.265625,3.21875 3.15625,3.21875 H 14.8125 V -3.34375 c 0,2.140625 1.5,3.65625 3.640625,3.65625 2.078125,0 3.59375,-1.515625 3.59375,-3.65625 v -34.453125 h 10.90625 c 1.828125,0 3.140625,-1.328125 3.140625,-3.21875 0,-1.828125 -1.3125,-3.078125 -3.140625,-3.078125 z m 0,0",
    id: "path845"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 9.328125,0.3125 c 2.078125,0 3.59375,-1.515625 3.59375,-3.65625 V -16.25 h 9.25 l 11.09375,14.984375 c 0.6875,0.953125 1.703125,1.578125 2.953125,1.578125 2.015625,0 3.40625,-1.453125 3.40625,-3.46875 0,-0.9375 -0.4375,-1.890625 -1.0625,-2.703125 l -8.578125,-11.53125 C 36.03125,-19.03125 40,-23.9375 40,-30.296875 40,-38.359375 33.828125,-44.09375 24.703125,-44.09375 h -15.375 c -2.140625,0 -3.65625,1.5 -3.65625,3.578125 V -3.34375 c 0,2.140625 1.515625,3.65625 3.65625,3.65625 z m 3.59375,-22.234375 v -16.0625 H 23.8125 c 5.546875,0 8.953125,3.390625 8.953125,8.0625 0,4.59375 -3.40625,8 -8.953125,8 z m 0,0",
    id: "path848"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.671875,-3.65625 C 5.671875,-1.515625 7.1875,0 9.328125,0 h 23.6875 c 1.890625,0 3.203125,-1.328125 3.203125,-3.28125 0,-1.890625 -1.3125,-3.203125 -3.203125,-3.203125 h -20.09375 v -34.34375 c 0,-2.078125 -1.515625,-3.59375 -3.59375,-3.59375 -2.140625,0 -3.65625,1.515625 -3.65625,3.59375 z m 0,0",
    id: "path851"
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "m 9.765625,-44.421875 c -2.203125,0 -3.78125,1.515625 -3.78125,3.65625 V -3.40625 c 0,2.203125 1.578125,3.71875 3.78125,3.71875 2.140625,0 3.71875,-1.515625 3.71875,-3.71875 v -37.359375 c 0,-2.140625 -1.578125,-3.65625 -3.71875,-3.65625 z m 0,0",
    id: "path854"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-42.149069,-179.36693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface23988",
    transform: "matrix(0.35277778,0,0,0.35277778,-6.36201,113.3272)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3047a3",
      strokeWidth: 100,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    },
    d: "m 1545.1172,4198.0078 c -66.25,0 -120,-53.75 -120,-120 v -634.0234 c 0,-66.25 53.75,-120 120,-120 h 4941.875 c 66.289,0 120,53.75 120,120 v 634.0234 c 0,66.25 -53.711,120 -120,120 z m 0,0",
    transform: "matrix(0.1,0,0,-0.1,0,612)",
    id: "path861"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g865"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 159.431,
    y: 258.302,
    id: "use863",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g869"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 212.85449,
    y: 258.302,
    id: "use867",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g873"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 262.62405,
    y: 258.302,
    id: "use871",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g877"
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 321.21368,
    y: 258.302,
    id: "use875",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g881"
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 366.88812,
    y: 258.302,
    id: "use879",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g885"
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 416.65775,
    y: 258.302,
    id: "use883",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g889"
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 468.88449,
    y: 258.302,
    id: "use887",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g893"
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 514.74823,
    y: 258.302,
    id: "use891",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g897"
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 543.03467,
    y: 258.302,
    id: "use895",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3047a3",
      fillOpacity: 1
    },
    id: "g901"
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 601.62421,
    y: 258.302,
    id: "use899",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3047a3",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    },
    d: "m 1625.7813,3756.0938 c 0,-127.1875 98.8671,-225.4297 228.5937,-225.4297 88.75,0 136.6016,39.6875 153.5938,56.0547 7.5781,6.914 13.2421,16.9921 13.2421,28.3593 0,18.8672 -13.8671,32.6953 -33.3593,32.6953 -10.0782,0 -18.9063,-5 -25.8203,-10.664 -17.6563,-15.7422 -47.8516,-39.6875 -106.4063,-39.6875 -89.4141,0 -157.4219,69.2578 -157.4219,159.9219 0,90.7031 68.0078,159.9609 157.4219,159.9609 57.2656,0 88.75,-24.5703 102.6172,-35.2734 6.9141,-5.0391 15.1172,-8.8282 24.5312,-8.8282 18.2813,0 33.3985,13.8672 33.3985,33.3594 0,13.2422 -6.9141,24.5703 -19.5313,33.3984 -20.1562,15.1172 -65.4687,44.0625 -139.7656,44.0625 -129.6875,0 -231.0937,-100.7421 -231.0937,-227.9296 z m 559.414,-182.5782 c 0,-21.4062 15.1172,-36.5234 36.5235,-36.5234 h 256.914 c 18.2422,0 30.8594,13.2031 30.8594,32.1094 0,18.2422 -12.6172,30.8593 -30.8594,30.8593 h -221.0156 v 135.9766 h 184.4922 c 17.6172,0 29.6094,11.9922 29.6094,29.6094 0,17.6172 -11.9922,29.6094 -29.6094,29.6094 h -184.4922 v 119.6093 h 214.6875 c 18.2812,0 30.8594,13.2422 30.8594,32.1094 0,18.2813 -12.5782,30.8594 -30.8594,30.8594 h -250.5859 c -21.4063,0 -36.5235,-15.1172 -36.5235,-35.8985 z m 497.6953,-3.789 c 0,-21.4063 14.4922,-35.8985 35.8985,-35.8985 20.7812,0 35.2734,14.4922 35.2734,35.8985 v 300.9765 l 227.9297,-312.3047 c 10.0781,-14.4921 24.5703,-24.5703 41.5625,-24.5703 25.1562,0 43.4375,18.8672 43.4375,44.7266 V 3946.25 c 0,20.1563 -14.4922,34.6484 -35.2734,34.6484 -20.7422,0 -35.2344,-14.4921 -35.2344,-34.6484 v -295.3125 l -224.1797,306.0156 c -10.0781,15.1172 -25.1563,23.9453 -41.5625,23.9453 -27.6953,0 -47.8516,-19.5312 -47.8516,-47.8515 z m 858.5547,408.0078 h -289.6484 c -18.8672,0 -31.4844,-12.5781 -31.4844,-30.8594 0,-18.8672 12.6172,-32.1094 31.4844,-32.1094 h 108.3203 v -344.414 c 0,-21.4063 15.1172,-36.5235 36.5234,-36.5235 20.7813,0 35.8985,15.1172 35.8985,36.5235 v 344.414 h 108.9062 c 18.2422,0 31.4844,13.2422 31.4844,32.1094 0,18.2813 -13.2422,30.8594 -31.4844,30.8594 z m 184.1016,-404.2188 c 0,-21.4062 15.1172,-36.5234 36.5234,-36.5234 h 256.875 c 18.2813,0 30.8594,13.2031 30.8594,32.1094 0,18.2422 -12.5781,30.8593 -30.8594,30.8593 h -220.9765 v 135.9766 h 184.4531 c 17.6562,0 29.6094,11.9922 29.6094,29.6094 0,17.6172 -11.9532,29.6094 -29.6094,29.6094 h -184.4531 v 119.6093 h 214.6875 c 18.2812,0 30.8593,13.2422 30.8593,32.1094 0,18.2813 -12.5781,30.8594 -30.8593,30.8594 h -250.586 c -21.4062,0 -36.5234,-15.1172 -36.5234,-35.8985 z m 534.2187,-39.6875 c 20.7813,0 35.8985,15.1172 35.8985,36.5235 v 129.0625 h 92.539 l 110.8203,-149.8438 c 6.9532,-9.4531 17.0313,-15.7422 29.6094,-15.7422 20.1563,0 33.9844,14.4922 33.9844,34.6485 0,9.414 -4.4141,18.8672 -10.7031,27.0703 l -85.625,115.1953 c 60.4687,16.4062 100.1171,65.5078 100.1171,129.1016 0,80.5859 -61.6796,137.8906 -153.0078,137.8906 h -153.6328 c -21.4062,0 -36.5234,-15.1172 -36.5234,-35.8985 v -371.4843 c 0,-21.4063 15.1172,-36.5235 36.5234,-36.5235 z m 35.8985,222.2657 v 160.5468 h 108.9062 c 55.4297,0 89.4141,-33.9843 89.4141,-80.5859 0,-45.9766 -33.9844,-79.9609 -89.4141,-79.9609 z m 449.8437,-182.5782 c 0,-21.4062 15.1172,-36.5234 36.5234,-36.5234 h 236.7579 c 18.8671,0 32.1093,13.2031 32.1093,32.7344 0,18.8672 -13.2422,32.1093 -32.1093,32.1093 H 4817.9297 V 3945 c 0,20.7422 -15.1172,35.8984 -35.8985,35.8984 -21.4062,0 -36.5234,-15.1562 -36.5234,-35.8984 z m 499.5703,407.3828 c -22.0312,0 -37.7734,-15.1562 -37.7734,-36.5234 v -373.3984 c 0,-22.0313 15.7422,-37.1485 37.7734,-37.1485 21.4063,0 37.1485,15.1172 37.1485,37.1485 v 373.3984 c 0,21.3672 -15.7422,36.5234 -37.1485,36.5234 z m 241.9531,-411.1718 c 0,-21.4063 14.4922,-35.8985 35.8594,-35.8985 20.8203,0 35.2735,14.4922 35.2735,35.8985 v 300.9765 l 227.9296,-312.3047 c 10.0782,-14.4921 24.5704,-24.5703 41.5625,-24.5703 25.1954,0 43.4375,18.8672 43.4375,44.7266 V 3946.25 c 0,20.1563 -14.4921,34.6484 -35.2343,34.6484 -20.7813,0 -35.2735,-14.4921 -35.2735,-34.6484 v -295.3125 l -224.1406,306.0156 c -10.0781,15.1172 -25.1953,23.9453 -41.5625,23.9453 -27.7344,0 -47.8516,-19.5312 -47.8516,-47.8515 z m 585.8594,3.789 c 0,-21.4062 15.1172,-36.5234 36.5235,-36.5234 h 256.914 c 18.2813,0 30.8594,13.2031 30.8594,32.1094 0,18.2422 -12.5781,30.8593 -30.8594,30.8593 h -221.0156 v 135.9766 h 184.4922 c 17.6172,0 29.6094,11.9922 29.6094,29.6094 0,17.6172 -11.9922,29.6094 -29.6094,29.6094 h -184.4922 v 119.6093 h 214.7266 c 18.2421,0 30.8593,13.2422 30.8593,32.1094 0,18.2813 -12.6172,30.8594 -30.8593,30.8594 h -250.625 c -21.4063,0 -36.5235,-15.1172 -36.5235,-35.8985 z m 0,0",
    transform: "matrix(0.1,0,0,-0.1,0,612)",
    id: "path903"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmarkBlue);
export default __webpack_public_path__ + "static/media/wordmark-blue.3aecfcf655e816934b2f21059387acf1.svg";
export { ForwardRef as ReactComponent };